export default function FaqData() {
  return [
    {
      title: 'Why Should an Insurance Policy Be Reviewed?',
      text: [
        "Many people buy an insurance policy, put it away in a safe place, and really never pay much attention to it other than paying its premiums. Specific types of insurance – term, whole life, universal or variable – are designed to address specific needs. Over time, a change may occur, either with the insurance need or with the performance of the policy insuring that need. Like other assets, a life insurance policy needs to be reviewed to determine whether it still meets your client’s needs and goals and is performing reasonably well to expectations. In other words, determining if your client is carrying the right amount of life insurance is likely to fluctuate at different times in their life.",
        'Your client’s life insurance policy was never meant to be a set-it-and-forget-it document. By regularly reviewing your client’s life insurance plan with a professional, you help ensure that their policy remains up to date and that they have adequate life coverage over the long term for their loved ones.'
      ]
    },
    {
      title: 'When should I review my client’s life insurance coverage?',
      text: ["The National Association of Insurance Commissioners (NAIC) suggests that your client regularly reviews their life insurance policy to determine if their coverage is still appropriate for their situation. In fact, most financial advisors and insurance professionals recommend reviewing your client's life insurance coverage annually. As a financial advisor, you can help your client make necessary policy modifications according to your client’s present needs, as well as examine the potential for changes in the coming years."]
    },
    {
      title: 'What Are Some Typical Events That Should Trigger a Policy Review?',
      text: [
        "Throughout your client's life, as their personal and financial situations evolve, a periodic review of life insurance coverage can help assure that they are appropriately protected. Any of the factors below may be a trigger for a consultation with an insurance professional:",
        `<ui>
            <li>Marriage</li>
            <li>Divorce</li>
            <li>The purchase of a new home</li>
            <li>The birth or adoption of a child</li>
            <li>Retirement</li>
            <li>A new job or promotion that has resulted in an increased standard of living</li>
            <li>Increased debt burden</li>
            <li>College education expenses</li>
            <li>Charitable giving</li>
            <li>Financial planning due to a death in the family</li>
            <li>Ownership in a business</li>
            <li>Planning for retirement</li>
        </ui>`
    ]
    },
    {
      title: 'How Should I Assess My Client’s Needs?',
      text: [
        "A number of factors can affect your client's life insurance needs. Consider the following factors when reviewing your client's life insurance coverage:",
        `
            <ol>

                <li> Changes in financial responsibilities. 
                    <ul> 
                        <li>Educational expenses, the cost of family health care, having to care for elderly parents or a special needs child – all present changes in your client's financial responsibilities. In fact, four in 10 households with children under 18 say they would immediately have trouble meeting everyday living expenses if the primary wage earner were to die today.1 An increase in your client's financial responsibilities might mean increasing their life insurance coverage. Be prepared to discuss these changes with your client.</li> 
                    </ul>
                </li>

                <li> An unexpected disability.
                    <ul> 
                        <li>In the event of an unexpected disability, how would your client pay their life insurance premium? Would it become a serious financial burden to your client and their family? Unfortunately, when disability strikes, a life insurance premium can feel like just another bill. For an additional cost, your client can add a waiver of premium rider that will continue to pay their life insurance premiums if they are unable to work due to an injury or illness. Their annual review is a great time to discuss policy riders that can help keep their coverage up to date.</li> 
                    </ul>
                </li>

                <li> New debts.
                    <ul>
                        <li>Has your client taken out a mortgage, financed a new vehicle, or borrowed capital to set up a new business? An annual policy review is the perfect time to discuss any new debts with your client so you can assess increasing their policy coverage accordingly.</li>
                    </ul>
                </li>

                <li> Changes in beneficiaries.
                    <ul>
                        <li>One of the most important decisions to make regarding life insurance is to whom your client leaves their benefits. During a regular review of your client's life insurance policy, take into consideration changes in their life, relationships, and family — such as births, adoptions, marriages, remarriages, divorces, and deaths — when updating their beneficiaries.</li>
                    </ul>
                </li>

            </ol>
        `
      ]
    },
    {
      title: 'What Are Some Basic Life Insurance Terms I Should Know?',
      text: [
        `
            <ul>
            
                <li> Policy owner
                    <ul> 
                        <li>The policy owner is the person who owns the life insurance policy. In many cases, the policy owner is also the person who is insured by the policy. However, the policy owner may also be a relative of the insured, a trust, partnership, or a corporation.
                        </li> 
                    </ul>
                </li>

                <li> Beneficiary
                    <ul> 
                        <li>A beneficiary is the person(s) selected by the policy owner to receive the life insurance payments upon the death of the insured.</li> 
                    </ul>
                </li>

                <li> Premium
                    <ul>
                        <li>Premiums are the payments made to the insurance company to purchase and keep a policy active.</li>
                    </ul>
                </li>

                <li> Death benefit
                    <ul>
                        <li>A death benefit is the amount paid to the beneficiary at the time of the death of the insured.</li>
                    </ul>
                </li>

                <li> Face amount
                    <ul>
                        <li>The face amount of the policy is the amount of the death benefit as stated in the policy. This does not include additional amounts that can accrue in certain types of policies.</li>
                    </ul>
                </li>

                <li> Insurability
                    <ul>
                        <li>Insurability refers to how likely an applicant is to be offered coverage based on current health, medical background, family history and other factors.</li>
                    </ul>
                </li>

            </ul>
        `
      ]
    },
    {
      title: 'How Much Life Insurance Does My Client Need?',
      text: [
        "Consider what your client's spouse and dependents would need in order to cover day-to-day bills and larger expenses, to live comfortably and to have financial stability. Don't forget to include savings for college and retirement. Also consider the effect of inflation over time; the amount needed for college, say, twenty years from now is likely to be significantly higher than today. Check out our life insurance calculator to determine how much life insurance may be right for your client."
      ]
    },
    {
      title: 'Why Does My Client Need Life Insurance?',
      text: [
        "A death in the family is not only emotionally tragic; it can also take a tremendous toll on the future financial security of a family. Suddenly, paying the mortgage or providing for a child's college education may become much more difficult. Those clients who make the decision to buy life insurance do so to help ensure their loved ones are taken care of financially."
      ]
    }
  ];
}



// WEBPACK FOOTER //
// ./src/components/Common/data/policy-review/FaqData.js